<template>
  <section class="box box--small-padding">
    <FetchJson :url="url" @fetched="onFetched">
      <template #default="{ json, loading }">
        <h2 class="box__header title-24">Прохождение этапов услуг</h2>
        <div v-if="!loading" style="width: 440px">
          <DonutChart
            :series="getRates(json)"
            :labels="labels"
            :colors="colors"
            :height="90"
            :legendOffsetX="80"
            :legendOffsetY="-5"
            :tooltipTitleFormatter="() => 'Количество услуг: '"
          />
        </div>
      </template>
    </FetchJson>
  </section>
</template>

<script>
import { ref, toRefs, computed } from "vue";
import { dateToString } from "@/modules/date";
import { dataIsEmpty } from "@/modules/number";
import FetchJson from "@/components/renderless/FetchJson";
import DonutChart from "@/components/common/DonutChart";

const labels = ["Все этапы пройдены", "Отсутствуют некоторые этапы"];
const colors = ["#518CFF", "#FCC8C2"];

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  components: {
    DonutChart,
    FetchJson,
  },
  setup(props) {
    const filter = toRefs(props.filter);
    const componentKey = ref(Date.now());
    const url = computed(
      () =>
        `services/service-stage-pass-percent?from=${dateToString(
          filter.from.value
        )}&to=${dateToString(filter.to.value)}&territory=${
          filter.territory.value.alias || ""
        }&serviceType=${filter.serviceType.value.alias || ""}`
    );
    const getRates = function (tableData) {
      return [
        dataIsEmpty(tableData.quantity) ? 0 : tableData.allStepsCompleteCount,
        dataIsEmpty(tableData.quantity)
          ? 0
          : tableData.notAllStepsCompleteCount,
      ];
    };

    return {
      componentKey,
      url,
      getRates,
      labels,
      colors,
    };
  },
  methods: {
    onFetched() {
      this.componentKey = Date.now(); // Tell Vue to re-create the component.
    },
  },
};
</script>

<style lang="scss">
.indicators.layout--horizontal {
  align-items: stretch;
}

.apexcharts-tooltip {
  // переопределяем стили apexchart-a через import, потому что там стиль задан у элемента, а не класса (см. документацию apexcharts)
  color: black !important;
}

.apexcharts-tooltip-series-group {
  background-color: white !important;
  border: 1px solid #465362 !important;
  border-radius: 4px !important;
  padding-bottom: 4px;
  padding-top: 4px;
}

.apexcharts-tooltip-text-value {
  margin-left: 0;
}
</style>
